import { render, staticRenderFns } from "./refund-policy-en.component.vue?vue&type=template&id=34117eda&scoped=true"
import script from "./refund-policy-en.component.ts?vue&type=script&lang=ts&external"
export * from "./refund-policy-en.component.ts?vue&type=script&lang=ts&external"
import style0 from "./refund-policy-en.component.vue?vue&type=style&index=0&id=34117eda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34117eda",
  null
  
)

export default component.exports